export default __webpack_public_path__ + "static/media/word.9b7d4011.svg";